import { useSelector } from "@/store";

export const useChannelConfig = () => {
  return useSelector((state) => {
    return state.channelConfig;
  });
};
